/* eslint-disable */
import { ErrorInfo } from 'react';
import { PATHS } from '../constants';
import { post } from './ajax';
const uppAPI = process.env.REACT_APP_UPP_API_URL;

const log = async (
  type: string,
  code: string,
  description: string,
  error: object,
) => {
  try {
    await post(`${uppAPI}${PATHS.LOG_PATH}`, {
      type,
      code,
      description,
      error,
    });
  } catch (e) {
    console.log('Failed to log error', e);
  }
};

export const debug = async (
  type: string,
  code: string,
  description: string,
  error: object,
) => {
  await log(type, code, description, error);
};

export const warn = async (
  type: string,
  code: string,
  description: string,
  error: object,
) => {
  await log(type, code, description, error);
};

export const error = async (
  type: string,
  code: string,
  description: string,
  error: object,
) => {
  await log(type, code, description, error);
};

export const info = async (
  type: string,
  code: string,
  description: string,
  error: object,
) => {
  await log(type, code, description, error);
};

export const logBoundaryError = (error: Error, info?: ErrorInfo) => {
  console.log('logBoundaryError error: ', error);
  console.log('logBoundaryError componentStack: ', info?.componentStack);
};
